import {
  RESET_USERS,
  RESET_USER,
  RESET_ERROR,
  GET_USERS,
  SET_USERS,
  API_ERROR,
  CREATE_USER,
  CREATE_USER_SUCCESS,
  GET_USER,
  SET_USER,
  EDIT_USER,
  EDIT_USER_SUCCESS,
  ACTIVATE_USER,
  ACTIVATE_USER_SUCCESS,
  RESET_USER_PASSWORD,
  RESET_USER_PASSWORD_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorUser: false,
  loadingUser: false,
  dataUser: null,
  successUser: false,

  resetPasswordUserSuccess: false,
  resetPasswordUserLoading: false,
  resetPasswordResponseMessage: null,
};

const User = (state = initialState, action) => {
  switch (action.type) {
    case RESET_USERS:
      state = {
        ...state,
        errorUser: false,
        loadingUser: false,
        loadingUserActivate: false,
        successUser: false,
        dataUser: null,
        dataUserActivate: null,
      };
      break;
    case RESET_USER:
      state = {
        ...state,
        errorUser: false,
        loadingUser: false,
        successUser: false,
        dataUserGetSet: null,
        dataUserEditCreate: null,
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        errorUser: false,
        loadingUser: false,
        loadingUserEditCreate: false,
        loadingUserActivate: false,
        successUser: false,
      };
      break;
    case GET_USERS:
      state = {
        ...state,
        errorUser: false,
        loadingUser: true,
        dataUser: null,
      };
      break;
    case SET_USERS:
      state = {
        ...state,
        errorUser: false,
        loadingUser: false,
        dataUser: action.payload,
      };
      break;
    case CREATE_USER:
      state = {
        ...state,
        errorUser: false,
        loadingUserEditCreate: true,
        dataUserEditCreate: action.payload,
        successUser: false,
      };
      break;
    case CREATE_USER_SUCCESS:
      state = {
        ...state,
        errorUser: false,
        loadingUserEditCreate: false,
        dataUserEditCreate: action.payload,
        successUser: true,
      };
      break;
    case GET_USER:
      state = {
        ...state,
        errorUser: false,
        loadingUser: true,
        dataUserGetSet: null,
      };
      break;
    case SET_USER:
      state = {
        ...state,
        errorUser: false,
        loadingUser: false,
        dataUserGetSet: action.payload,
      };
      break;
    case EDIT_USER:
      state = {
        ...state,
        errorUser: false,
        loadingUserEditCreate: true,
        dataUserEditCreate: action.payload,
        successUser: false,
      };
      break;
    case EDIT_USER_SUCCESS:
      state = {
        ...state,
        errorUser: false,
        loadingUserEditCreate: false,
        dataUserEditCreate: action.payload,
        successUser: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorUser: action.payload,
        loadingUser: false,
        loadingUserActivate: false,
        successUser: false,
        resetPasswordUserLoading: false,
      };
      break;
    case ACTIVATE_USER:
      state = {
        ...state,
        errorUser: false,
        loadingUserActivate: true,
        dataUserActivate: action.payload,
        successUser: false,
      };
      break;
    case ACTIVATE_USER_SUCCESS:
      state = {
        ...state,
        errorUser: false,
        loadingUserActivate: false,
        dataUserActivate: action.payload,
        successUser: true,
      };
      break;
    case RESET_USER_PASSWORD_SUCCESS:
      state = {
        ...state,
        resetPasswordUserSuccess: true,
        resetPasswordUserLoading: false,
        resetPasswordResponseMessage: action.payload,
      };
      break;
    case RESET_USER_PASSWORD:
      state = {
        ...state,
        resetPasswordUserSuccess: false,
        resetPasswordUserLoading: true,
      };
      break;
    default:
      // state = { ...state, errorUser: false, loadingUser: false };
      break;
  }
  return state;
};

export default User;
